module.exports = __webpack_public_path__ + "img/logo_icon.1abcb770.svg";